import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert, Container } from '@mui/material';
import { useAuth } from '@/context/AuthContext';
import { authApi } from '@/services/api';

export default function GitHubCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { handleLogin } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const code = searchParams.get('code');

    if (!code) {
      setError('Missing authentication data');
      return;
    }

    authApi
      .exchangeCode(code)
      .then(({ data }) => {
        handleLogin(data);
        navigate('/', { replace: true });
      })
      .catch(() => {
        setError('Failed to complete sign in — please try again');
      });
  }, [searchParams, handleLogin, navigate]);

  if (error) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#F5F5F7',
        }}
      >
        <Container maxWidth="sm">
          <Alert severity="error">{error}</Alert>
        </Container>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress sx={{ mr: 2 }} />
      <Typography>Completing sign in...</Typography>
    </Box>
  );
}
